export enum AssetKind {
  Film,
  Map,
  Playlist,
  Prefab,
  TestAsset,
  UgcGameVariant,
  MapModePair,
  Project,
  Manifest,
  EngineGameVariant,
}
